import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grit-sand-volume-calculator',
  templateUrl: './grit-sand-volume-calculator.component.html',
  styleUrls: ['./grit-sand-volume-calculator.component.scss']
})
export class GritSandVolumeCalculatorComponent implements OnInit {

  constructor() { }
  totalSqm: number;
  mortar: number;
  defaultMortar:boolean;
  ratioFirst:number;
  ratioSecond:number;
  defaultRatio:boolean;
  defaultMortarValue = 50;
  defaultFirstRatio = 3;
  defaultSecondRatio = 1;
  m3OfSandAndCement = 0.016;
  costOf25Bags :number;
  tonneBags :number;
  totalCementIn25KgBags:number;
  bestSandPrice:number;

  F4:number;
  J4:number;
  I4:number;
  J9=3.50;
  K9=60;
  O4:number;
  I9=6;
  totalPrice:number;
  K13:number;
  totalSandPrice:number;
 
  
  
  

  ngOnInit(): void {
  }

  materialCostChange(searchValue): void {  

    if(this.defaultMortar == true){
      this.mortar = this.defaultMortarValue;
    }
    if(this.defaultRatio == true){
      this.ratioFirst = this.defaultFirstRatio;
      this.ratioSecond = this.defaultSecondRatio;
    }

    this.calculateMaterialDesign();
   
  }

  calculateMaterialDesign(){

    let A4 = this.totalSqm;
    let B4 = this.mortar;
    let A10 = this.ratioFirst;
    let B10 = this.ratioSecond;
    let G4 = this.m3OfSandAndCement;
    let oneBagSandCost = 60;



  let d4 = A4*(B4/1000);

  /**total sand in 25kg bags **/
  this.F4 = d4/G4;
  

  let C13 = A10+B10;
  let D13 = this.F4/C13;
  /**Tone Bags **/
  this.J4 = D13*A10;


  this.I4 =(D13*B10);
/** Best sand price */
  let M4 = this.J4*25;
   this.K13 = M4/800;
 
  let R4 = this.K13*this.K9;
  let P4 = this.J4*this.J9;

  this.bestSandPrice = P4/R4;

 /** Total Sand Price**/

this.totalSandPrice = Math.ceil(this.K13)*oneBagSandCost;


  /**cement price **/

  this.O4 = this.I4*this.I9;

  this.totalPrice = this.O4+(this.bestSandPrice); 
 


  
  

  }

}
